import { onAuthStateChanged, User } from "@firebase/auth";
import React, { useReducer } from "react";
import { firebaseAuth } from "utils/config/firebase.config";

export type AuthState = User | null | undefined;

const authReducer = (state: AuthState, action: any) => {
  switch (action.type) {
    case "login":
      return action.payload;
    case "logout":
      return null;
  }
  return state;
};

export const AuthContext = React.createContext<AuthState>(undefined);

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [authState, dispatch] = useReducer(authReducer, undefined);
  AuthContext.displayName = "Auth Context";
  onAuthStateChanged(firebaseAuth, (user) => {
    if (user) {
      dispatch({ type: "login", payload: user });
    } else {
      dispatch({ type: "logout" });
    }
  });

  return <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>;
};

export default AuthContext;
